import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
export default {
  name: "cpt-carousel",
  props: {
    height: {
      type: Number,
      default: 168
    },
    option: Object
  }
};